export enum MediaOverviewOrderColumn {
  fileName = 'filename',
  resourceName = 'resource_name',
  avgEngagement = 'avg_engagement',
  playsCount = 'plays_count',
  uniquePlaysCount = 'unique_plays_count',
  impressionsCount = 'impressions_count',
  uniqueImpressionsCount = 'unique_impressions_count',
  playRate = 'play_rate',
  lastActivity = 'last_activity',
  createdAt = 'created_at',
  totalPlayTime = 'total_play_time_ms'
}

export enum MediaImpressionsOverviewOrderColumn {
  displayName = 'displayName',
  engagementPercent = 'engagement_percent',
  playTimeSeconds = 'play_time_seconds',
  updatedAt = 'updated_at'
}
